import { API_BASE_URL } from './forms';

type FormEventName = 'form_viewed' | 'form_started' | 'form_completed';

interface TrackEventPayload {
  durationMs?: number;
}

export async function trackFormEvent(
  projectId: string,
  formId: string,
  event: FormEventName,
  payload?: TrackEventPayload,
): Promise<void> {
  try {
    await fetch(
      `${API_BASE_URL}/forms/public/projects/${encodeURIComponent(projectId)}/forms/${encodeURIComponent(formId)}/events`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event,
          ...payload,
        }),
      },
    );
  } catch {
    // analytics events are fire-and-forget
  }
}
